import { alpha, Box, Container, Divider, Grid, lighten, Link, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import AppFooter from '../layout/AppFooter'
import AppHeader from '../layout/AppHeader'
import Shell from '../layout/Shell'

export default function LandingCard() {
    const { t } = useTranslation()

    return (
        <Shell>
            <AppHeader />
            <Container maxWidth="md" sx={{ py: { xs: 5, md: 8 }, flexGrow: 1 }}>
                <Stack spacing={4} justifyContent={"center"} alignItems={"center"}>
                    <Stack spacing={2} textAlign={"center"} maxWidth={"72ch"}>
                        <Typography variant="h1" color="primary">Validação dos dados de titularidade do seu domínio</Typography>
                        <Typography color="text.secondary" fontSize={16}>
                            Para garantir o cumprimento do Regime Jurídico dos Nomes de Domínio (RJC), aprovado pelo Decreto-Lei n.º 125/2025, e das obrigações de cibersegurança da Diretiva NIS2, a validação dos dados de titularidade é obrigatória.
                        </Typography>
                        <Typography color="text.secondary" fontSize={16}>
                            {t('landing.referral')}
                        </Typography>
                    </Stack>
                    <Grid container spacing={3}>
                        <Grid size={{
                            xs: 12, sm: 6, md: 7,
                        }}>
                            <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 }, bgcolor: 'background.paper', height: '100%' }}>
                                <Stack spacing={2.5} >
                                    <Typography variant='h4' color="primary">
                                        Validação dos dados de contacto
                                    </Typography>
                                    <Typography color="text.secondary" fontSize={16}>
                                        Nesta página pode fazer a validação dos dados de contacto para o seu NIC-HANDLE.
                                    </Typography>
                                    <Divider flexItem />
                                    <Stack
                                        direction={"row"}
                                        spacing={1}
                                        useFlexGap
                                        alignItems={"center"}
                                        justifyContent={"start"}
                                    >
                                        <Typography variant="inherit" fontWeight={"bold"} color="primary">
                                            ›
                                        </Typography>
                                        <Typography fontSize={13.5} color='text.secondary'>
                                            Para mais detalhes, contacte o seu fornecedor.
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Paper>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12, sm: 6, md: 5,
                            }}
                        >
                            <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 }, bgcolor: 'primary.main', color: "primary.contrastText" }}>
                                <Stack spacing={2.5}>
                                    <Typography variant='subtitle1'>
                                        Enquadramento legal
                                    </Typography>
                                    <Stack
                                        direction={"row"}
                                        spacing={1}
                                        sx={{
                                            color: (theme) => lighten(theme.palette.primary.main, 0.7)
                                        }}
                                        useFlexGap
                                        alignItems={"start"}
                                        justifyContent={"start"}
                                    >
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            flexShrink={0}
                                            sx={{
                                                borderRadius: 1,
                                                width: "32px !important",
                                                height: "32px !important",
                                                backgroundColor: (theme) => alpha(theme.palette.secondary.light, 0.2),
                                                color: (theme) => lighten(theme.palette.secondary.main, 0.5)
                                            }}
                                        >
                                            <Typography variant="inherit">
                                                ✔
                                            </Typography>
                                        </Box>
                                        <Typography fontSize={13}>
                                            Regime Jurídico dos Nomes de Domínio (RJC), Decreto-Lei n.º 125/2025.
                                        </Typography>
                                    </Stack>
                                    <Stack
                                        direction={"row"}
                                        spacing={1}
                                        sx={{
                                            color: (theme) => lighten(theme.palette.primary.main, 0.7)
                                        }}
                                        useFlexGap
                                        alignItems={"start"}
                                        justifyContent={"start"}
                                    >
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            flexShrink={0}
                                            sx={{
                                                borderRadius: 1,
                                                width: "32px !important",
                                                height: "32px !important",
                                                backgroundColor: (theme) => alpha(theme.palette.secondary.light, 0.2),
                                                color: (theme) => lighten(theme.palette.secondary.main, 0.5)
                                            }}
                                        >
                                            <Typography variant="inherit">
                                                ✔
                                            </Typography>
                                        </Box>
                                        <Typography fontSize={13}>
                                            Obrigações de cibersegurança da Diretiva NIS2.
                                        </Typography>
                                    </Stack>
                                    <Stack
                                        direction={"row"}
                                        spacing={1}
                                        sx={{
                                            color: (theme) => lighten(theme.palette.primary.main, 0.7)
                                        }}
                                        useFlexGap
                                        alignItems={"start"}
                                        justifyContent={"start"}
                                    >
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            flexShrink={0}
                                            sx={{
                                                borderRadius: 1,
                                                width: "32px !important",
                                                height: "32px !important",
                                                backgroundColor: (theme) => alpha(theme.palette.secondary.light, 0.2),
                                                color: (theme) => lighten(theme.palette.secondary.main, 0.5)
                                            }}
                                        >
                                            <Typography variant="inherit">
                                                ✔
                                            </Typography>
                                        </Box>
                                        <Typography fontSize={13.5}>
                                            A validação dos dados de titularidade é obrigatória.
                                        </Typography>
                                    </Stack>
                                    <Divider flexItem />
                                    <Stack spacing={0.5}>
                                        <Typography variant='subtitle2'
                                            sx={{
                                                color: (theme) => lighten(theme.palette.primary.main, 0.7)
                                            }}
                                        >
                                            CONTACTO
                                        </Typography>
                                        <Link
                                            href="mailto:info@verifique.pt"
                                            target="_blank"
                                            rel="noreferrer"
                                            sx={{
                                                textDecoration: "none",
                                                color: (theme) => lighten(theme.palette.secondary.main, 0.5),
                                                fontSize: (theme) => theme.typography.subtitle1.fontSize,
                                                fontWeight: (theme) => theme.typography.subtitle2.fontWeight
                                            }}
                                        >
                                            info@verifique.pt
                                        </Link>
                                    </Stack>

                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Stack>
            </Container>
            <AppFooter />
        </Shell>
    )
}
